export class PaginationHelpers {
  static get rowsPerPageOptions() {
    return [5, 10, 20, 50];
  }

  static initRowsPerPageOptions(multiplier = 1) {
    return [5, 10, 20, 30, 50, 100].map((number) => number * multiplier);
  }

  static get maxPagesDisplay() {
    return 5;
  }

  static syncFromQTable({ oldValue, newValue: { page, rowsPerPage, sortBy, descending } } = {}) {
    oldValue.page = page;
    oldValue.rowsPerPage = rowsPerPage;
    oldValue.sortBy = sortBy;
    oldValue.descending = descending;
  }

  static initializePagination({ page = 1, rowsPerPage = 10, rowsNumber = 0 } = {}) {
    return {
      page,
      rowsPerPage,
      rowsNumber,
    };
  }

  static getPageNumber(total, maxPage) {
    const pagesNumber = total / maxPage;
    return Math.ceil(pagesNumber) || 1;
  }
}
